import blogImg from "../assets/images/mediaImg.webp";

const blogData = [
	{
		id: "1",
		title: "Why AV Integration Matters in 2025",
		date: "August 20, 2025",
		image: blogImg,
		content: [
			"AV integration is essential for modern businesses to streamline communication and enhance productivity.",
			"With hybrid workspaces becoming the norm, seamless audio-visual setups ensure efficient collaboration.",
			"Businesses investing in AV now will see long-term ROI and better internal operations.",
		],
	},
	{
		id: "2",
		title: "Top 5 Used Cameras in Broadcast",
		date: "August 18, 2025",
		image: blogImg,
		content: [
			"Broadcast professionals often prefer used gear for budget efficiency without compromising quality.",
			"This blog highlights 5 top-performing used cameras that deliver pro-grade output.",
			"We evaluated image quality, durability, and resale value.",
		],
	},
	{
		id: "3",
		title: "Guide to Media Migration Workflows",
		date: "August 15, 2025",
		image: blogImg,
		content: [
			"Media migration requires careful planning, especially when dealing with legacy formats.",
			"This guide helps you establish a reliable workflow from ingest to archive.",
			"Preserve and digitize your media archives the right way.",
		],
	},
	{
		id: "4",
		title: "How to Consign Equipment Safely",
		date: "August 12, 2025",
		image: blogImg,
		content: [
			"Consignment is a smart way to sell used equipment with minimal hassle.",
			"Learn how to protect yourself legally and get the best market value.",
			"We walk through trusted platforms and tips for success.",
		],
	},
	{
		id: "5",
		title: "Best Practices in Equipment Maintenance",
		date: "August 10, 2025",
		image: blogImg,
		content: [
			"Maintaining your AV gear prolongs lifespan and ensures optimal performance.",
			"We cover cleaning techniques, storage, and scheduled maintenance tips.",
			"Avoid unexpected breakdowns and preserve resale value.",
		],
	},
	{
		id: "6",
		title: "Production Packages for Indie Creators",
		date: "August 8, 2025",
		image: blogImg,
		content: [
			"Indie creators need flexible, affordable production gear that scales.",
			"This post outlines essential packages for film, YouTube, and streaming.",
			"We include camera, audio, and lighting bundles within budget ranges.",
		],
	},
	{
		id: "7",
		title: "Why You Should Digitize Your Tape Archive",
		date: "August 5, 2025",
		image: blogImg,
		content: [
			"Tape degradation is real — waiting too long can cost you irreplaceable content.",
			"Digitization secures your media for future access and reuse.",
			"Find out what formats are most vulnerable and how to start digitizing today.",
		],
	},
	{
		id: "8",
		title: "Upcoming Trends in Broadcast Tech",
		date: "August 3, 2025",
		image: blogImg,
		content: [
			"From IP-based production to virtual sets, broadcast tech is evolving fast.",
			"Discover what tools and standards will shape the next 5 years.",
			"Early adoption gives your team an edge in a competitive landscape.",
		],
	},
	{
		id: "9",
		title: "Buying vs Leasing Broadcast Equipment",
		date: "August 1, 2025",
		image: blogImg,
		content: [
			"Both buying and leasing have pros and cons depending on your project scope.",
			"This article breaks down financial, technical, and operational factors.",
			"Make the right decision to save costs and maintain flexibility.",
		],
	},
];

export default blogData;
